import React, { useEffect } from "react";
import {
  ViedocButtonElement,
  ViedocDialogElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";

const CloseConfirmationPopUp = ({ setShowCloseConfirmation }) => {
  const { t } = useTranslation();
  useEffect(() => {
    document
      .getElementById("doc-close")
      .addEventListener("dialog-hide", (e) => {
        e.stopPropagation();
        setShowCloseConfirmation(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const documentCloseHandler = () => {
    document.getElementById("doc-view-popup")?.hide();
  };

  const documentCloseCancelhandler = (e) => {
    e.stopPropagation();
    setShowCloseConfirmation(false);
  };

  return (
    <ViedocDialogElement
      id="doc-close"
      size="small"
      open
      class=""
      preventCloseByClick
    >
      <main className="close-document">
        <div className="close-option">
          <viedoc-icon class="close-confirmation" name="warning"></viedoc-icon>
          <label className="">{t("CONFIRMATION_POPUP.UNSAVE_CHANGES")}</label>
          <span>{t("CONFIRMATION_POPUP.DISCARD_CHANGES_CONFIRMATION")}</span>
          <div className="pt-20 bt-2 fileName">
            <ViedocButtonElement
              class="mr-10 warning-color"
              variant="neutral"
              size="small"
              onClick={() => documentCloseHandler()}
              title={t("CONFIRMATION_POPUP.DISCARD_CHANGES")}
            >
              {t("CONFIRMATION_POPUP.DISCARD_CHANGES")}
            </ViedocButtonElement>
            <ViedocButtonElement
              class="mr-10"
              variant="neutral"
              size="small"
              onClick={(e) => documentCloseCancelhandler(e)}
              title={t("CONFIRMATION_POPUP.CONTINUE_EDITING")}
            >
              {t("CONFIRMATION_POPUP.CONTINUE_EDITING")}
            </ViedocButtonElement>
          </div>
        </div>
      </main>
    </ViedocDialogElement>
  );
};

export default CloseConfirmationPopUp;
